import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { SimService } from './../../../services/sim.service';
import { ClienteVM } from './../../../../../_entities/clientes/ClienteVM';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PlanTarifarioI } from './../../../../../_entities/sims/PlanTarifario';
import { TelefoniaI } from './../../../../../_entities/sims/Telefonia';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'kt-alta-sim',
	templateUrl: './alta-sim.component.html',
	styleUrls: ['./alta-sim.component.scss']
})
export class AltaSimComponent implements OnInit {
	public telefonias: TelefoniaI[];
	public planesTarifarios: PlanTarifarioI[];
	public clientesRegistros: ClienteVM[];
	public simsForm: FormGroup;
	public loading: boolean = false;
	public idSim: any;
	public titulo: string = 'Agregar Sim'

	constructor(private simServices: SimService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private toastService: ToastrService) { }

	ngOnInit() {
		this.initForm();
		this.route.params.subscribe(
			param => {
				this.idSim = param["idSim"];
				if (this.idSim) {
					this.titulo = 'Editar Sim'
					this.obtenerSim(this.idSim);
					this.simsForm.controls.sim.clearValidators();
				}
			}
		);
		this.obtenerClientes();
		this.obtenerTelefonia();
		this.obtenerPlanesTarifarios();
	}

	initForm() {
		this.simsForm = this.fb.group({
			sim: ['', Validators.required],
			numeroTelefonico: ['', Validators.compose([Validators.required])],
			idCliente: ['', Validators.compose([Validators.required])],
			idTelefonia: ['', Validators.compose([Validators.required])],
			idPlan: ['', Validators.compose([Validators.required])]
		});
	}

	obtenerClientes() {
		this.simServices.obtenerClientes(true).subscribe(
			(response) => {
				this.clientesRegistros = response;
			}, (error) => {
				console.log('Error al Obtener los clientes');
			}
		);
	}

	obtenerSim(idSim) {
		this.simServices.obtenerSimId(idSim).subscribe(
			(response) => {
				this.simsForm.setValue({
					sim: response.sim,
					numeroTelefonico: response.numeroTelefonico,
					idCliente: response.idCliente,
					idTelefonia: response.idTelefonia,
					idPlan: response.idPLan
				});
			}, (error) => {
				this.toastService.error('Error al intentar obtener los datos del sim');
			});
	}

	obtenerTelefonia() {
		this.simServices.obtenerTelefonias().subscribe(
			(response: TelefoniaI[]) => {
				this.telefonias = response;
			}
		)
	}

	obtenerPlanesTarifarios() {
		this.simServices.obtenerPlanesTarifarios().subscribe(
			(response: PlanTarifarioI[]) => {
				this.planesTarifarios = response;
			}
		)
	}

	onSubmit() {
		if (this.idSim) this.actualizarSim();
		else this.agregarSim();
	}

	onCancel() {
		this.router.navigateByUrl('/home/administracion/sims/sim');
	}

	agregarSim() {
		this.loading = true;
		this.simServices.guardarSim(this.simsForm.value).subscribe(
			() => {
				this.loading = false;
				this.simsForm.reset();
				this.toastService.success('Sim guardado correctamente', 'Bien hecho');
				this.router.navigateByUrl('/home/administracion/sims/sim');
			}, () => {
				this.toastService.error('Error al guardar el sim');
				this.loading = false;
			});
	}

	actualizarSim() {
		this.simServices.actualizarSim(this.simsForm.value, this.idSim).subscribe(
			() => {
				this.toastService.success('Se guardaron los datos correctamente', 'Bien hecho');
				this.router.navigateByUrl('/home/administracion/sims/sim');
			}, () => {
				this.toastService.error('Error al guardar el sim');
			}
		);
	}




}
